'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    (0, _jquery2.default)('[data-close-modal="true"]', this).each(function () {
        (0, _jquery2.default)(this).closest(".modal").modal('hide');
        (0, _jquery2.default)(this).closest(".modal").removeData('bs.modal');
        (0, _jquery2.default)(this).removeAttr('data-close-modal');
    });
};

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/closeModal.js
// module id = 417
// module chunks = 0